import en from './locale/en';
import es from './locale/es';
import fr from './locale/fr';
import pt_BR from './locale/pt_BR';

export default {
  en,
  es,
  fr,
  pt_BR,
};
